// app.routes.ts
import { Routes } from '@angular/router';
import { AuthGuard } from './awasBandhu/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./awasBandhu/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'districts',
    loadComponent: () =>
      import('./awasBandhu/district/district.component').then((m) => m.DistrictComponent),
    canActivate: [AuthGuard],
  },
 {
        path: 'sessionpassword',
        loadComponent: () =>
          import('./awasBandhu/session-password/session-password.component').then(
            (m) => m.SessionPasswordComponent
          ),
            //  canActivate: [AuthGuard],  

        },

  {
    path: 'dashboards',
    loadComponent: () =>
      import('./awasBandhu/awasLayouts/awaslayouts.component').then(
        (m) => m.AwaslayoutsComponent
      ),
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'index',
        loadComponent: () =>
          import('./awasBandhu/dashboard/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
       
      {
        path: 'welcome',
        loadComponent: () =>
          import('./awasBandhu/dashboard/welcome/welcome.component').then(
            (m) => m.WelcomeComponent
          ),
      },
        // {
  //       path: 'sessionpassword',
  //       loadComponent: () =>
  //         import('./awasBandhu/dashboard/session-password/session-password.component').then(
  //           (m) => m.SessionPasswordComponent
  //         ),
  //          canActivate: [AuthGuard],
  //     },
      {
        path: 'profile',
        loadComponent: () =>
          import('./awasBandhu/dashboard/profile/profile.component').then(
            (m) => m.ProfileComponent
          ),
      },
      {
        path: 'password',
        loadComponent: () =>
          import('./awasBandhu/dashboard/password/password.component').then(
            (m) => m.PasswordComponent
          ),
      },
      {
        path: 'feedback',
        loadComponent: () =>
          import('./awasBandhu/dashboard/feedback/feedback.component').then(
            (m) => m.FeedbackComponent
          ),
      },
      {
        path: 'forms',
        loadComponent: () =>
          import('./awasBandhu/dashboard/forms/forms.component').then(
            (m) => m.FormsComponent
          ),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./awasBandhu/dashboard/reports/reports.component').then(
            (m) => m.ReportsComponent
          ),
                     

      },
      {
        path: 'cm_dash',
        loadComponent: () =>
          import('./awasBandhu/dashboard/cm-dash/cm-dash.component').then(
            (m) => m.CmDashComponent
          ),
           data: { role: 'A' } 
      },

      {
        path: 'finalized',
        loadComponent: () =>
          import('./awasBandhu/dashboard/finalized/finalized.component').then(
            (m) => m.FinalizedComponent
          ),
      },
      {
        path: 'draft',
        loadComponent: () =>
          import('./awasBandhu/dashboard/draft/draft.component').then(
            (m) => m.DraftComponent
          ),
      },
      {
        path: 'pending',
        loadComponent: () =>
          import('./awasBandhu/dashboard/pending/pending.component').then(
            (m) => m.PendingComponent
          ),
      },

      {
        path: 'corrections',
        loadComponent: () =>
          import('./awasBandhu/dashboard/corrections/corrections.component').then(
            (m) => m.CorrectionsComponent
          ),
      },

      {
        path: 'admin-finalized',
        loadComponent: () =>
          import('./awasBandhu/dashboard/admin-finalized/admin-finalized.component').then(
            (m) => m.AdminFinalizedComponent
          ),
      },
      {
        path: 'admin-draft',
        loadComponent: () =>
          import('./awasBandhu/dashboard/admin-draft/admin-draft.component').then(
            (m) => m.AdminDraftComponent
          ),
      },
      {
        path: 'admin-pendings',
        loadComponent: () =>
          import('./awasBandhu/dashboard/admin-pendings/admin-pendings.component').then(
            (m) => m.AdminPendingsComponent
          ),
      },
      {
        path: 'admin-corrections',
        loadComponent: () =>
          import('./awasBandhu/dashboard/admin-corrections/admin-corrections.component').then(
            (m) => m.AdminCorrectionsComponent
          ),
      },
      {
        path: 'authorityRegistration',
        loadComponent: () =>
          import('./awasBandhu/dashboard/authority-registration/authority-registration.component').then(
            (m) => m.AuthorityRegistrationComponent
          ),
            data: { role: 'A' } 
        
      },
      {
        path: 'addform/:id',
        loadComponent: () =>
          import('./awasBandhu/master/commonSecondforms/common-secondforms/common-secondforms.component').then(
            (m) => m.CommonSecondformsComponent
          ),
      },
      //   {
      //   path: 'specialform/:id',
      //   loadComponent: () =>
      //     import('./awasBandhu/master/commonSecondforms/common-firstforms/common-firstforms.component').then(
      //       (m) => m.CommonFirstformsComponent
      //     ),
      // },
      {
        path: 'formtable/:id',
        loadComponent: () =>
          import('./awasBandhu/master/commontable/commontable.component').then(
            (m) => m.CommontableComponent
          ),
      },
      {
        path: 'error',
        loadComponent: () =>
          import('./awasBandhu/master/server-down/server-down.component').then(
            (m) => m.ServerDownComponent
          ),
      },
      {
        path: '',
        redirectTo: 'index',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
